// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "transactionGroup.proto" (package "transaction", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SplitOverride } from "./transaction";
/**
 * @generated from protobuf message transaction.TransactionGroupMember
 */
export interface TransactionGroupMember {
    /**
     * @generated from protobuf field: string email = 1
     */
    email: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: optional uint32 splitValue = 3
     */
    splitValue?: number;
    /**
     * @generated from protobuf field: bool joined = 4
     */
    joined: boolean;
}
/**
 * @generated from protobuf message transaction.TransactionGroup
 */
export interface TransactionGroup {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string initial_currency = 3
     */
    initialCurrency: string;
    /**
     * @generated from protobuf field: transaction.SplitType splitType = 4
     */
    splitType: SplitType;
    /**
     * @generated from protobuf field: repeated transaction.TransactionGroupMember members = 5
     */
    members: TransactionGroupMember[];
    /**
     * @generated from protobuf field: optional uint32 currency = 6
     */
    currency?: number;
    /**
     * @generated from protobuf field: optional uint32 category = 7
     */
    category?: number;
    /**
     * @generated from protobuf field: bool hidden = 8
     */
    hidden: boolean;
    /**
     * @generated from protobuf field: string initial_currency_symbol = 9
     */
    initialCurrencySymbol: string;
    /**
     * @generated from protobuf field: uint32 initial_currency_decimal_points = 10
     */
    initialCurrencyDecimalPoints: number;
    /**
     * @generated from protobuf field: string created_at = 11
     */
    createdAt: string;
}
/**
 * @generated from protobuf message transaction.GetAllTransactionGroupsRequest
 */
export interface GetAllTransactionGroupsRequest {
}
/**
 * @generated from protobuf message transaction.GetAllTransactionGroupsResponse
 */
export interface GetAllTransactionGroupsResponse {
    /**
     * @generated from protobuf field: repeated transaction.TransactionGroup transactionGroups = 1
     */
    transactionGroups: TransactionGroup[];
}
/**
 * @generated from protobuf message transaction.CreateTransactionGroupRequest
 */
export interface CreateTransactionGroupRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string initial_currency = 2
     */
    initialCurrency: string;
    /**
     * @generated from protobuf field: transaction.SplitType splitType = 3
     */
    splitType: SplitType;
    /**
     * @generated from protobuf field: optional uint32 currency = 4
     */
    currency?: number;
    /**
     * @generated from protobuf field: optional uint32 category = 5
     */
    category?: number;
    /**
     * @generated from protobuf field: string initial_currency_symbol = 6
     */
    initialCurrencySymbol: string;
    /**
     * @generated from protobuf field: uint32 initial_currency_decimal_points = 7
     */
    initialCurrencyDecimalPoints: number;
}
/**
 * @generated from protobuf message transaction.CreateTransactionGroupResponse
 */
export interface CreateTransactionGroupResponse {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message transaction.UpdateGroupMemberFields
 */
export interface UpdateGroupMemberFields {
    /**
     * @generated from protobuf field: string email = 1
     */
    email: string;
    /**
     * @generated from protobuf field: optional uint32 splitValue = 3
     */
    splitValue?: number;
}
/**
 * @generated from protobuf message transaction.UpdateTransactionGroupFields
 */
export interface UpdateTransactionGroupFields {
    /**
     * @generated from protobuf field: optional string name = 1
     */
    name?: string;
    /**
     * @generated from protobuf field: optional transaction.SplitType splitType = 2
     */
    splitType?: SplitType;
    /**
     * @generated from protobuf field: optional uint32 currency = 3
     */
    currency?: number;
    /**
     * @generated from protobuf field: optional uint32 category = 4
     */
    category?: number;
    /**
     * @generated from protobuf field: repeated transaction.UpdateGroupMemberFields members = 5
     */
    members: UpdateGroupMemberFields[];
    /**
     * @generated from protobuf field: optional bool hidden = 6
     */
    hidden?: boolean;
}
/**
 * @generated from protobuf message transaction.UpdateTransactionGroupRequest
 */
export interface UpdateTransactionGroupRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: transaction.UpdateTransactionGroupFields fields = 2
     */
    fields?: UpdateTransactionGroupFields;
}
/**
 * @generated from protobuf message transaction.UpdateTransactionGroupResponse
 */
export interface UpdateTransactionGroupResponse {
}
/**
 * @generated from protobuf message transaction.ChangeTransactionGroupSplitRequest
 */
export interface ChangeTransactionGroupSplitRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: transaction.SplitType splitType = 2
     */
    splitType: SplitType;
    /**
     * @generated from protobuf field: repeated transaction.UpdateGroupMemberFields members = 3
     */
    members: UpdateGroupMemberFields[];
    /**
     * @generated from protobuf field: transaction.SplitChangeScope scope = 4
     */
    scope: SplitChangeScope;
}
/**
 * @generated from protobuf message transaction.ChangeTransactionGroupSplitResponse
 */
export interface ChangeTransactionGroupSplitResponse {
}
/**
 * @generated from protobuf message transaction.SetGroupedTransactionSplitRequest
 */
export interface SetGroupedTransactionSplitRequest {
    /**
     * @generated from protobuf field: uint32 transaction_id = 1
     */
    transactionId: number;
    /**
     * @generated from protobuf field: optional transaction.SplitOverride split_override = 2
     */
    splitOverride?: SplitOverride;
}
/**
 * @generated from protobuf message transaction.SetGroupedTransactionSplitResponse
 */
export interface SetGroupedTransactionSplitResponse {
}
/**
 * @generated from protobuf message transaction.DeleteTransactionGroupRequest
 */
export interface DeleteTransactionGroupRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message transaction.DeleteTransactionGroupResponse
 */
export interface DeleteTransactionGroupResponse {
}
/**
 * @generated from protobuf enum transaction.SplitType
 */
export enum SplitType {
    /**
     * @generated from protobuf enum value: Equal = 0;
     */
    Equal = 0,
    /**
     * @generated from protobuf enum value: Percentage = 1;
     */
    Percentage = 1,
    /**
     * @generated from protobuf enum value: Share = 2;
     */
    Share = 2
}
/**
 * @generated from protobuf enum transaction.SplitChangeScope
 */
export enum SplitChangeScope {
    /**
     * @generated from protobuf enum value: AllTransactions = 0;
     */
    AllTransactions = 0,
    /**
     * @generated from protobuf enum value: TransactionsWithoutCustomSplit = 1;
     */
    TransactionsWithoutCustomSplit = 1,
    /**
     * @generated from protobuf enum value: FutureTransactions = 2;
     */
    FutureTransactions = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class TransactionGroupMember$Type extends MessageType<TransactionGroupMember> {
    constructor() {
        super("transaction.TransactionGroupMember", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "splitValue", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "joined", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TransactionGroupMember>): TransactionGroupMember {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.email = "";
        message.name = "";
        message.joined = false;
        if (value !== undefined)
            reflectionMergePartial<TransactionGroupMember>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TransactionGroupMember): TransactionGroupMember {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* optional uint32 splitValue */ 3:
                    message.splitValue = reader.uint32();
                    break;
                case /* bool joined */ 4:
                    message.joined = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TransactionGroupMember, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* optional uint32 splitValue = 3; */
        if (message.splitValue !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.splitValue);
        /* bool joined = 4; */
        if (message.joined !== false)
            writer.tag(4, WireType.Varint).bool(message.joined);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.TransactionGroupMember
 */
export const TransactionGroupMember = new TransactionGroupMember$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransactionGroup$Type extends MessageType<TransactionGroup> {
    constructor() {
        super("transaction.TransactionGroup", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "initial_currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "splitType", kind: "enum", T: () => ["transaction.SplitType", SplitType] },
            { no: 5, name: "members", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TransactionGroupMember },
            { no: 6, name: "currency", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "category", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "hidden", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "initial_currency_symbol", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "initial_currency_decimal_points", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 11, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TransactionGroup>): TransactionGroup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.name = "";
        message.initialCurrency = "";
        message.splitType = 0;
        message.members = [];
        message.hidden = false;
        message.initialCurrencySymbol = "";
        message.initialCurrencyDecimalPoints = 0;
        message.createdAt = "";
        if (value !== undefined)
            reflectionMergePartial<TransactionGroup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TransactionGroup): TransactionGroup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string initial_currency */ 3:
                    message.initialCurrency = reader.string();
                    break;
                case /* transaction.SplitType splitType */ 4:
                    message.splitType = reader.int32();
                    break;
                case /* repeated transaction.TransactionGroupMember members */ 5:
                    message.members.push(TransactionGroupMember.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional uint32 currency */ 6:
                    message.currency = reader.uint32();
                    break;
                case /* optional uint32 category */ 7:
                    message.category = reader.uint32();
                    break;
                case /* bool hidden */ 8:
                    message.hidden = reader.bool();
                    break;
                case /* string initial_currency_symbol */ 9:
                    message.initialCurrencySymbol = reader.string();
                    break;
                case /* uint32 initial_currency_decimal_points */ 10:
                    message.initialCurrencyDecimalPoints = reader.uint32();
                    break;
                case /* string created_at */ 11:
                    message.createdAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TransactionGroup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string initial_currency = 3; */
        if (message.initialCurrency !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.initialCurrency);
        /* transaction.SplitType splitType = 4; */
        if (message.splitType !== 0)
            writer.tag(4, WireType.Varint).int32(message.splitType);
        /* repeated transaction.TransactionGroupMember members = 5; */
        for (let i = 0; i < message.members.length; i++)
            TransactionGroupMember.internalBinaryWrite(message.members[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* optional uint32 currency = 6; */
        if (message.currency !== undefined)
            writer.tag(6, WireType.Varint).uint32(message.currency);
        /* optional uint32 category = 7; */
        if (message.category !== undefined)
            writer.tag(7, WireType.Varint).uint32(message.category);
        /* bool hidden = 8; */
        if (message.hidden !== false)
            writer.tag(8, WireType.Varint).bool(message.hidden);
        /* string initial_currency_symbol = 9; */
        if (message.initialCurrencySymbol !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.initialCurrencySymbol);
        /* uint32 initial_currency_decimal_points = 10; */
        if (message.initialCurrencyDecimalPoints !== 0)
            writer.tag(10, WireType.Varint).uint32(message.initialCurrencyDecimalPoints);
        /* string created_at = 11; */
        if (message.createdAt !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.TransactionGroup
 */
export const TransactionGroup = new TransactionGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTransactionGroupsRequest$Type extends MessageType<GetAllTransactionGroupsRequest> {
    constructor() {
        super("transaction.GetAllTransactionGroupsRequest", []);
    }
    create(value?: PartialMessage<GetAllTransactionGroupsRequest>): GetAllTransactionGroupsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllTransactionGroupsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTransactionGroupsRequest): GetAllTransactionGroupsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTransactionGroupsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.GetAllTransactionGroupsRequest
 */
export const GetAllTransactionGroupsRequest = new GetAllTransactionGroupsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTransactionGroupsResponse$Type extends MessageType<GetAllTransactionGroupsResponse> {
    constructor() {
        super("transaction.GetAllTransactionGroupsResponse", [
            { no: 1, name: "transactionGroups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TransactionGroup }
        ]);
    }
    create(value?: PartialMessage<GetAllTransactionGroupsResponse>): GetAllTransactionGroupsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionGroups = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllTransactionGroupsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTransactionGroupsResponse): GetAllTransactionGroupsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated transaction.TransactionGroup transactionGroups */ 1:
                    message.transactionGroups.push(TransactionGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTransactionGroupsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated transaction.TransactionGroup transactionGroups = 1; */
        for (let i = 0; i < message.transactionGroups.length; i++)
            TransactionGroup.internalBinaryWrite(message.transactionGroups[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.GetAllTransactionGroupsResponse
 */
export const GetAllTransactionGroupsResponse = new GetAllTransactionGroupsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTransactionGroupRequest$Type extends MessageType<CreateTransactionGroupRequest> {
    constructor() {
        super("transaction.CreateTransactionGroupRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "initial_currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "splitType", kind: "enum", T: () => ["transaction.SplitType", SplitType] },
            { no: 4, name: "currency", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "category", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "initial_currency_symbol", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "initial_currency_decimal_points", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<CreateTransactionGroupRequest>): CreateTransactionGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.initialCurrency = "";
        message.splitType = 0;
        message.initialCurrencySymbol = "";
        message.initialCurrencyDecimalPoints = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateTransactionGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateTransactionGroupRequest): CreateTransactionGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string initial_currency */ 2:
                    message.initialCurrency = reader.string();
                    break;
                case /* transaction.SplitType splitType */ 3:
                    message.splitType = reader.int32();
                    break;
                case /* optional uint32 currency */ 4:
                    message.currency = reader.uint32();
                    break;
                case /* optional uint32 category */ 5:
                    message.category = reader.uint32();
                    break;
                case /* string initial_currency_symbol */ 6:
                    message.initialCurrencySymbol = reader.string();
                    break;
                case /* uint32 initial_currency_decimal_points */ 7:
                    message.initialCurrencyDecimalPoints = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateTransactionGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string initial_currency = 2; */
        if (message.initialCurrency !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.initialCurrency);
        /* transaction.SplitType splitType = 3; */
        if (message.splitType !== 0)
            writer.tag(3, WireType.Varint).int32(message.splitType);
        /* optional uint32 currency = 4; */
        if (message.currency !== undefined)
            writer.tag(4, WireType.Varint).uint32(message.currency);
        /* optional uint32 category = 5; */
        if (message.category !== undefined)
            writer.tag(5, WireType.Varint).uint32(message.category);
        /* string initial_currency_symbol = 6; */
        if (message.initialCurrencySymbol !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.initialCurrencySymbol);
        /* uint32 initial_currency_decimal_points = 7; */
        if (message.initialCurrencyDecimalPoints !== 0)
            writer.tag(7, WireType.Varint).uint32(message.initialCurrencyDecimalPoints);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.CreateTransactionGroupRequest
 */
export const CreateTransactionGroupRequest = new CreateTransactionGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTransactionGroupResponse$Type extends MessageType<CreateTransactionGroupResponse> {
    constructor() {
        super("transaction.CreateTransactionGroupResponse", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<CreateTransactionGroupResponse>): CreateTransactionGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateTransactionGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateTransactionGroupResponse): CreateTransactionGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateTransactionGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.CreateTransactionGroupResponse
 */
export const CreateTransactionGroupResponse = new CreateTransactionGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateGroupMemberFields$Type extends MessageType<UpdateGroupMemberFields> {
    constructor() {
        super("transaction.UpdateGroupMemberFields", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "splitValue", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateGroupMemberFields>): UpdateGroupMemberFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.email = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateGroupMemberFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateGroupMemberFields): UpdateGroupMemberFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* optional uint32 splitValue */ 3:
                    message.splitValue = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateGroupMemberFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* optional uint32 splitValue = 3; */
        if (message.splitValue !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.splitValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateGroupMemberFields
 */
export const UpdateGroupMemberFields = new UpdateGroupMemberFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTransactionGroupFields$Type extends MessageType<UpdateTransactionGroupFields> {
    constructor() {
        super("transaction.UpdateTransactionGroupFields", [
            { no: 1, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "splitType", kind: "enum", opt: true, T: () => ["transaction.SplitType", SplitType] },
            { no: 3, name: "currency", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "category", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "members", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UpdateGroupMemberFields },
            { no: 6, name: "hidden", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateTransactionGroupFields>): UpdateTransactionGroupFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.members = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateTransactionGroupFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateTransactionGroupFields): UpdateTransactionGroupFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string name */ 1:
                    message.name = reader.string();
                    break;
                case /* optional transaction.SplitType splitType */ 2:
                    message.splitType = reader.int32();
                    break;
                case /* optional uint32 currency */ 3:
                    message.currency = reader.uint32();
                    break;
                case /* optional uint32 category */ 4:
                    message.category = reader.uint32();
                    break;
                case /* repeated transaction.UpdateGroupMemberFields members */ 5:
                    message.members.push(UpdateGroupMemberFields.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional bool hidden */ 6:
                    message.hidden = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateTransactionGroupFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string name = 1; */
        if (message.name !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* optional transaction.SplitType splitType = 2; */
        if (message.splitType !== undefined)
            writer.tag(2, WireType.Varint).int32(message.splitType);
        /* optional uint32 currency = 3; */
        if (message.currency !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.currency);
        /* optional uint32 category = 4; */
        if (message.category !== undefined)
            writer.tag(4, WireType.Varint).uint32(message.category);
        /* repeated transaction.UpdateGroupMemberFields members = 5; */
        for (let i = 0; i < message.members.length; i++)
            UpdateGroupMemberFields.internalBinaryWrite(message.members[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* optional bool hidden = 6; */
        if (message.hidden !== undefined)
            writer.tag(6, WireType.Varint).bool(message.hidden);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateTransactionGroupFields
 */
export const UpdateTransactionGroupFields = new UpdateTransactionGroupFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTransactionGroupRequest$Type extends MessageType<UpdateTransactionGroupRequest> {
    constructor() {
        super("transaction.UpdateTransactionGroupRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "fields", kind: "message", T: () => UpdateTransactionGroupFields }
        ]);
    }
    create(value?: PartialMessage<UpdateTransactionGroupRequest>): UpdateTransactionGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateTransactionGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateTransactionGroupRequest): UpdateTransactionGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* transaction.UpdateTransactionGroupFields fields */ 2:
                    message.fields = UpdateTransactionGroupFields.internalBinaryRead(reader, reader.uint32(), options, message.fields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateTransactionGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* transaction.UpdateTransactionGroupFields fields = 2; */
        if (message.fields)
            UpdateTransactionGroupFields.internalBinaryWrite(message.fields, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateTransactionGroupRequest
 */
export const UpdateTransactionGroupRequest = new UpdateTransactionGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTransactionGroupResponse$Type extends MessageType<UpdateTransactionGroupResponse> {
    constructor() {
        super("transaction.UpdateTransactionGroupResponse", []);
    }
    create(value?: PartialMessage<UpdateTransactionGroupResponse>): UpdateTransactionGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateTransactionGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateTransactionGroupResponse): UpdateTransactionGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateTransactionGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateTransactionGroupResponse
 */
export const UpdateTransactionGroupResponse = new UpdateTransactionGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChangeTransactionGroupSplitRequest$Type extends MessageType<ChangeTransactionGroupSplitRequest> {
    constructor() {
        super("transaction.ChangeTransactionGroupSplitRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "splitType", kind: "enum", T: () => ["transaction.SplitType", SplitType] },
            { no: 3, name: "members", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UpdateGroupMemberFields },
            { no: 4, name: "scope", kind: "enum", T: () => ["transaction.SplitChangeScope", SplitChangeScope] }
        ]);
    }
    create(value?: PartialMessage<ChangeTransactionGroupSplitRequest>): ChangeTransactionGroupSplitRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.splitType = 0;
        message.members = [];
        message.scope = 0;
        if (value !== undefined)
            reflectionMergePartial<ChangeTransactionGroupSplitRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChangeTransactionGroupSplitRequest): ChangeTransactionGroupSplitRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* transaction.SplitType splitType */ 2:
                    message.splitType = reader.int32();
                    break;
                case /* repeated transaction.UpdateGroupMemberFields members */ 3:
                    message.members.push(UpdateGroupMemberFields.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* transaction.SplitChangeScope scope */ 4:
                    message.scope = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChangeTransactionGroupSplitRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* transaction.SplitType splitType = 2; */
        if (message.splitType !== 0)
            writer.tag(2, WireType.Varint).int32(message.splitType);
        /* repeated transaction.UpdateGroupMemberFields members = 3; */
        for (let i = 0; i < message.members.length; i++)
            UpdateGroupMemberFields.internalBinaryWrite(message.members[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* transaction.SplitChangeScope scope = 4; */
        if (message.scope !== 0)
            writer.tag(4, WireType.Varint).int32(message.scope);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.ChangeTransactionGroupSplitRequest
 */
export const ChangeTransactionGroupSplitRequest = new ChangeTransactionGroupSplitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChangeTransactionGroupSplitResponse$Type extends MessageType<ChangeTransactionGroupSplitResponse> {
    constructor() {
        super("transaction.ChangeTransactionGroupSplitResponse", []);
    }
    create(value?: PartialMessage<ChangeTransactionGroupSplitResponse>): ChangeTransactionGroupSplitResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ChangeTransactionGroupSplitResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChangeTransactionGroupSplitResponse): ChangeTransactionGroupSplitResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChangeTransactionGroupSplitResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.ChangeTransactionGroupSplitResponse
 */
export const ChangeTransactionGroupSplitResponse = new ChangeTransactionGroupSplitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGroupedTransactionSplitRequest$Type extends MessageType<SetGroupedTransactionSplitRequest> {
    constructor() {
        super("transaction.SetGroupedTransactionSplitRequest", [
            { no: 1, name: "transaction_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "split_override", kind: "message", T: () => SplitOverride }
        ]);
    }
    create(value?: PartialMessage<SetGroupedTransactionSplitRequest>): SetGroupedTransactionSplitRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionId = 0;
        if (value !== undefined)
            reflectionMergePartial<SetGroupedTransactionSplitRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetGroupedTransactionSplitRequest): SetGroupedTransactionSplitRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 transaction_id */ 1:
                    message.transactionId = reader.uint32();
                    break;
                case /* optional transaction.SplitOverride split_override */ 2:
                    message.splitOverride = SplitOverride.internalBinaryRead(reader, reader.uint32(), options, message.splitOverride);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetGroupedTransactionSplitRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 transaction_id = 1; */
        if (message.transactionId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.transactionId);
        /* optional transaction.SplitOverride split_override = 2; */
        if (message.splitOverride)
            SplitOverride.internalBinaryWrite(message.splitOverride, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.SetGroupedTransactionSplitRequest
 */
export const SetGroupedTransactionSplitRequest = new SetGroupedTransactionSplitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGroupedTransactionSplitResponse$Type extends MessageType<SetGroupedTransactionSplitResponse> {
    constructor() {
        super("transaction.SetGroupedTransactionSplitResponse", []);
    }
    create(value?: PartialMessage<SetGroupedTransactionSplitResponse>): SetGroupedTransactionSplitResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetGroupedTransactionSplitResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetGroupedTransactionSplitResponse): SetGroupedTransactionSplitResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetGroupedTransactionSplitResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.SetGroupedTransactionSplitResponse
 */
export const SetGroupedTransactionSplitResponse = new SetGroupedTransactionSplitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTransactionGroupRequest$Type extends MessageType<DeleteTransactionGroupRequest> {
    constructor() {
        super("transaction.DeleteTransactionGroupRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteTransactionGroupRequest>): DeleteTransactionGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteTransactionGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteTransactionGroupRequest): DeleteTransactionGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteTransactionGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.DeleteTransactionGroupRequest
 */
export const DeleteTransactionGroupRequest = new DeleteTransactionGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTransactionGroupResponse$Type extends MessageType<DeleteTransactionGroupResponse> {
    constructor() {
        super("transaction.DeleteTransactionGroupResponse", []);
    }
    create(value?: PartialMessage<DeleteTransactionGroupResponse>): DeleteTransactionGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteTransactionGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteTransactionGroupResponse): DeleteTransactionGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteTransactionGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.DeleteTransactionGroupResponse
 */
export const DeleteTransactionGroupResponse = new DeleteTransactionGroupResponse$Type();
/**
 * @generated ServiceType for protobuf service transaction.TransactionGroupService
 */
export const TransactionGroupService = new ServiceType("transaction.TransactionGroupService", [
    { name: "GetAllTransactionGroups", options: {}, I: GetAllTransactionGroupsRequest, O: GetAllTransactionGroupsResponse },
    { name: "CreateTransactionGroup", options: {}, I: CreateTransactionGroupRequest, O: CreateTransactionGroupResponse },
    { name: "UpdateTransactionGroup", options: {}, I: UpdateTransactionGroupRequest, O: UpdateTransactionGroupResponse },
    { name: "ChangeTransactionGroupSplit", options: {}, I: ChangeTransactionGroupSplitRequest, O: ChangeTransactionGroupSplitResponse },
    { name: "SetGroupedTransactionSplit", options: {}, I: SetGroupedTransactionSplitRequest, O: SetGroupedTransactionSplitResponse },
    { name: "DeleteTransactionGroup", options: {}, I: DeleteTransactionGroupRequest, O: DeleteTransactionGroupResponse }
]);
